import React from 'react'

const XCloseButton = ({ onClick }) => (
  <div className="op-xclose-button" onClick={onClick}>
    <div className="op-xclose-button__icon op-icon-cancel" />
  </div>
)

export default XCloseButton
